<template>
   <v-card class="cardSize">
        <v-toolbar color="primary" :title="name"></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <h5>MEDIDAS</h5>
              </v-col>
              <v-col> </v-col>
            </v-row>
            <v-row v-for="(opcion, index) in opciones" :key="index">
              <!-- Columna para la medida -->
              <v-col cols="6" class="d-flex align-items-center">
                <li>{{ opcion.medida }}</li>
              </v-col>

              <!-- Columna para los botones y el campo de texto -->

              <v-col cols="4" class="d-flex align-items-center">
                <v-text-field
                  label="Cantidad"
                  v-model.number="opcion.cantidad"
                  style="font-size: smaller"
                  placeholder="cantidad"
                  variant="solo"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="green-darken-3"
                  @click="incrementarCantidad(index)"
                  size="small"
                  >+</v-btn
                >
                <v-spacer style="height: 5px"></v-spacer>
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="red-darken-3"
                  @click="decrementarCantidad(index)"
                  size="small"
                  >-</v-btn
                >
                <v-spacer style="height: 5px"></v-spacer>
                <v-btn
                  class="txtbutton"
                  variant="flat"
                  color="orange-darken-3"
                  @click="addProductToCart(opcion.id+selectColor.id, name, opcion, selectColor)"
                  size="small"
                  ><span class="mdi mdi-cart-plus"></span
                ></v-btn>
              </v-col>
              <v-select
                label="Colores" 
                :items="colores"
                item-title="color"
                return-object
                variant="solo"
                v-model="selectColor"
              ></v-select>
              <v-divider></v-divider>
            </v-row>
           
          </v-container>
        </v-card-text>
      </v-card>
</template>


<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    colores: {
      type: Array,
      default: () => []
    },
    name: {
      type: String,
      default: ''
    },
    opciones: {
      type: Array,
      default: () => []
    }
  },
mounted() {
 
},
  data() {
    return {
      precioTotal: 0,
      selectColor:[]
    };
  },

  computed: {
    ...mapGetters(['cartItems']),
  },

  methods: {
    incrementarCantidad(index) {
      this.opciones[index].cantidad++;
    },
    decrementarCantidad(index) {
      if (this.opciones[index].cantidad > 0) {
        this.opciones[index].cantidad--;
      }
    },

    ...mapActions(['addToCart', 'removeFromCart']),

    addProductToCart(id, nombre, data, selectColor) {
      var item = {
        id: id,
        nombre: nombre,
        datos: data,
        color:selectColor
      };
      this.addToCart(item)
    },
    removeProductFromCart(productId) {
      this.removeFromCart(productId);
    },
  },
};
</script>

<style scoped>
@media (min-width: 1000px) {
  /* Ajusta este valor según el breakpoint que desees */
  .cardSize {
    width: 500px;
  }
}

@media (max-width: 999px) {
  .cardSize {
    margin: auto;
  }
}
.txtbutton {
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: medium;
}
</style>
